import React from "react";
import SimpleLookupPage from "./SimpleLookupPage";
import useLeisureActivities from "../../hooks/useLeisureActivities";
import { LEISURE_ACTIVITY_ICON_OPTIONS } from "../../utils/leisureActivityIcons";

export default function LeisureActivitiesPage() {
    const {
        leisureActivities,
        loading,
        error,
        fetchLeisureActivities,
        createLeisureActivity,
        updateLeisureActivity,
        deleteLeisureActivity,
    } = useLeisureActivities();

    return (
        <SimpleLookupPage
            title="Freizeit & Sport"
            itemLabel="Freizeit/Sport"
            searchLabel="Freizeit/Sport suchen"
            items={leisureActivities}
            loading={loading}
            error={error}
            fetchItems={fetchLeisureActivities}
            createItem={createLeisureActivity}
            updateItem={updateLeisureActivity}
            deleteItem={deleteLeisureActivity}
            iconOptions={LEISURE_ACTIVITY_ICON_OPTIONS}
        />
    );
}
